/**
 * MFE Hooks — reusable React hooks for MFE infrastructure.
 */
import { useState, useEffect } from 'react'
import MFEBus from './MFEBus'
import MFEStore from './MFEStore'

/** Subscribe to a named bus event with automatic cleanup. */
export function useMFEBus(event, handler, deps = []) {
  useEffect(() => {
    const off = MFEBus.on(event, handler)
    return off
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}

/** Read and reactively subscribe to the shared MFE store. */
export function useMFEStore() {
  const [s, setS] = useState(MFEStore.get)
  useEffect(() => MFEStore.subscribe(setS), [])
  return [s, MFEStore.set]
}
